/**
 * Getting from one record to the other: a job to its invoice, an invoice to its job.
 *
 * <p>🔑 ONE mechanism, two links. Both crossings are the same idea — go to the page
 * that owns the other record and arrive with it OPEN, rather than at a list to search —
 * so the URL shape, the parameter and the consuming side are written once and the two
 * differ only by route and parameter name. Two near-copies would drift the moment one
 * of them learned something the other did not.
 */

/**
 * A deep link builder: `/invoices?invoice=<uuid>`, `/jobs?job=<uuid>`.
 *
 * @param {string} path the page that owns the record
 * @param {string} param the query parameter that page consumes
 */
const deepLinkTo = (path, param) => (uuid) => `${path}?${param}=${encodeURIComponent(uuid)}`;

/** The parameter each page reads. Exported so the consumer and the builder cannot drift. */
export const INVOICE_PARAM = 'invoice';
export const JOB_PARAM = 'job';

/** Where an invoice is opened: the Invoices page consumes `?invoice=`. */
export const invoiceDeepLink = deepLinkTo('/invoices', INVOICE_PARAM);

/** Where a job is opened: the Jobs board consumes `?job=`. */
export const jobDeepLink = deepLinkTo('/jobs', JOB_PARAM);
